import { format } from 'date-fns';

/** Цвета chip'а HTTP-метода (по дизайн-токенам). */
export const METHOD_STYLES: Record<string, { bg: string; color: string }> = {
  POST: { bg: 'var(--color-success-tint)', color: 'var(--color-success)' },
  PATCH: { bg: 'var(--color-warning-tint)', color: 'var(--color-warning)' },
  DELETE: { bg: 'var(--color-error-tint)', color: 'var(--color-error)' },
};

/** Unix-секунды → строка `dd.MM.yyyy HH:mm:ss`. */
export function formatTimestamp(sec: number | null | undefined): string {
  if (!sec) return '—';
  return format(new Date(sec * 1000), 'dd.MM.yyyy HH:mm:ss');
}

/** Unix-секунды → значение для `<input type="datetime-local">` (локальное время). */
export function unixToLocalInput(sec?: number): string {
  if (!sec) return '';
  const d = new Date(sec * 1000);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Значение `datetime-local` → Unix-секунды (или undefined). */
export function localInputToUnix(value: string): number | undefined {
  if (!value) return undefined;
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? undefined : Math.floor(ms / 1000);
}
